import { Base } from 'firepuma-vue-axios-vuex-extensions/axios-utils/apiBase';

export class Api extends Base {
  async listAlerts() {
    const response = await this.api().get(`v1/broileradmin/alerts`);
    return this.handleResponse(response);
  }
}

export const BroilerAdminAPI = new Api();



// WEBPACK FOOTER //
// ./src/broilerAdmin/store/_api.js